// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as MediaApiModel$PorterinFeature from "../../../../shared/media/domain/api-models/MediaApiModel.mjs";
import * as SharedApiModel$PorterinFeature from "../../../../shared/core/domain/api-models/SharedApiModel.mjs";

function profile_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var city = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city"), null));
    if (city.TAG === /* Ok */0) {
      var image = MediaApiModel$PorterinFeature.image_src_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
      if (image.TAG === /* Ok */0) {
        var description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
        if (description.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    name: name._0,
                    city: city._0,
                    image: image._0,
                    description: description._0
                  }
                };
        }
        var e = description._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".description" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = image._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".image" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = city._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".city" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function testimonial_section_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var profiles = Decco.arrayFromJson(profile_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "profiles"), null));
    if (profiles.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                title: title._0,
                profiles: profiles._0
              }
            };
    }
    var e = profiles._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".profiles" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function partner_own_vehicle_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var sub_title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_title"), null));
    if (sub_title.TAG === /* Ok */0) {
      var action = SharedApiModel$PorterinFeature.link_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "action"), null));
      if (action.TAG === /* Ok */0) {
        var image = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
        if (image.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    title: title._0,
                    sub_title: sub_title._0,
                    action: action._0,
                    image: image._0
                  }
                };
        }
        var e = image._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".image" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = action._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".action" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = sub_title._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_title" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function attributes_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var hero_section = SharedApiModel$PorterinFeature.hero_section_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hero_section"), null));
  if (hero_section.TAG === /* Ok */0) {
    var porter_advantage = SharedApiModel$PorterinFeature.image_title_desc_container_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "porter_advantage"), null));
    if (porter_advantage.TAG === /* Ok */0) {
      var life_easy_section = SharedApiModel$PorterinFeature.image_title_desc_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "life_easy_section"), null));
      if (life_easy_section.TAG === /* Ok */0) {
        var additioanal_benifits = SharedApiModel$PorterinFeature.image_title_desc_container_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "additioanal_benifits"), null));
        if (additioanal_benifits.TAG === /* Ok */0) {
          var testimonial_section = testimonial_section_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "testimonial_section"), null));
          if (testimonial_section.TAG === /* Ok */0) {
            var faq_section = SharedApiModel$PorterinFeature.faqs_section_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "faq_section"), null));
            if (faq_section.TAG === /* Ok */0) {
              var download_app = SharedApiModel$PorterinFeature.image_title_desc_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "download_app"), null));
              if (download_app.TAG === /* Ok */0) {
                var partner_own_vehicle = partner_own_vehicle_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "partner_own_vehicle"), null));
                if (partner_own_vehicle.TAG === /* Ok */0) {
                  var meta_data = SharedApiModel$PorterinFeature.meta_json_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "meta_data"), null));
                  if (meta_data.TAG === /* Ok */0) {
                    var get_partner_cta = SharedApiModel$PorterinFeature.know_more_cta_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "get_partner_cta"), null));
                    if (get_partner_cta.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: {
                                hero_section: hero_section._0,
                                porter_advantage: porter_advantage._0,
                                life_easy_section: life_easy_section._0,
                                additioanal_benifits: additioanal_benifits._0,
                                testimonial_section: testimonial_section._0,
                                faq_section: faq_section._0,
                                download_app: download_app._0,
                                partner_own_vehicle: partner_own_vehicle._0,
                                meta_data: meta_data._0,
                                get_partner_cta: get_partner_cta._0
                              }
                            };
                    }
                    var e = get_partner_cta._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".get_partner_cta" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = meta_data._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".meta_data" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }
                var e$2 = partner_own_vehicle._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".partner_own_vehicle" + e$2.path,
                          message: e$2.message,
                          value: e$2.value
                        }
                      };
              }
              var e$3 = download_app._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".download_app" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                      }
                    };
            }
            var e$4 = faq_section._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".faq_section" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = testimonial_section._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".testimonial_section" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
        }
        var e$6 = additioanal_benifits._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".additioanal_benifits" + e$6.path,
                  message: e$6.message,
                  value: e$6.value
                }
              };
      }
      var e$7 = life_easy_section._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".life_easy_section" + e$7.path,
                message: e$7.message,
                value: e$7.value
              }
            };
    }
    var e$8 = porter_advantage._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".porter_advantage" + e$8.path,
              message: e$8.message,
              value: e$8.value
            }
          };
  }
  var e$9 = hero_section._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".hero_section" + e$9.path,
            message: e$9.message,
            value: e$9.value
          }
        };
}

function data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = attributes_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = data_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  profile_decode ,
  testimonial_section_decode ,
  partner_own_vehicle_decode ,
  attributes_decode ,
  data_decode ,
  t_decode ,
}
/* No side effect */
